import React, { useState, useEffect } from "react";
import Axios from "axios";

import CreditCard from "react-credit-cards";
import swal from "sweetalert";
import { Form, Button, Loader } from "semantic-ui-react";

import InputNext from "../../components/Form/FormData/Input";
import SelectNext from "../../components/Form/FormData/Select";

import Topo from "../../components/Topo";
import Footer from "../../components/Footer";

import { producaov2 as api } from "../../services/apis";
import { getNodeToken, getUserNode } from "../../services/auth_node";
import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
  GetCreditCardBrand,
} from "../InscricaoNode/utils";

import {
  Container,
  Box,
  Header,
  CreditCardDiv,
  Dimmer,
  FormLine,
  FormContainer,
} from "./styles";
import {
  birthdayValidate,
  cpfValidation,
  mandatoryValidate,
  nameValidate,
  phoneValidate,
} from "../../utils/validators";

const PagamentoVindi = (props) => {
  document.title = "Assinatura Especial | Grupo Voitto";

  const [dados, setDados] = useState({});
  const [fullData, setFullData] = useState(false);
  const [cartao, setCartao] = useState({
    name: "",
    number: "",
    expiry: "",
    cvc: "",
  });
  const [focused, setFocused] = useState("name");
  const [loading, setLoading] = useState(true);
  const [pago, setPago] = useState(false);

  const [name, setName] = useState({
    value: "",
    message: "",
    info: "Nome completo para certificado",
  });
  const [phone, setPhone] = useState({
    value: "",
    message: "",
  });
  const [cpf, setCpf] = useState({
    value: "",
    message: "",
  });
  const [birthday, setBirthday] = useState({
    value: "",
    message: "",
  });
  const [postalCode, setPostalCode] = useState({
    value: "",
    message: "",
  });
  const [street, setStreet] = useState({
    value: "",
    message: "",
  });
  const [number, setNumber] = useState({
    value: "",
    message: "",
  });
  const [complement, setComplement] = useState({
    value: "",
    message: "",
  });
  const [neightboor, setNeightboor] = useState({
    value: "",
    message: "",
  });
  const [city, setCity] = useState({
    value: "",
    message: "",
  });
  const [state, setState] = useState({
    value: "",
    message: "",
  });
  const [ufs, setUfs] = useState([]);
  const [cities, setCities] = useState([]);

  const handleInputCard = ({ target }) => {
    let value = target.value;

    if (target.name === "number") {
      target.value = formatCreditCardNumber(target.value);
    } else if (target.name === "expiry") {
      target.value = formatExpirationDate(target.value);
    } else if (target.name === "cvc") {
      target.value = formatCVC(target.value);
    }

    setCartao({ ...cartao, [target.name]: value });
  };

  const handleInputFocus = ({ target }) => {
    setFocused(target.name);
  };

  const handleSubmitCard = () => {
    if (!cartao.cvc || !cartao.expiry || !cartao.name || !cartao.number) {
      swal("Atenção", "Preencha todos dados do cartão", "warning");
      return;
    }

    setLoading(true);
    const card = {
      titular: cartao.name,
      numero: cartao.number,
      mesValidade: cartao.expiry.split("/")[0],
      anoValidade: "20" + cartao.expiry.split("/")[1],
      cvv: cartao.cvc,
      expiry: cartao.expiry,
      bandeira: GetCreditCardBrand(cartao.number),
    };

    const vindi_params = {
      nome: getUserNode().nome,
      email: getUserNode().email,
      parcelas: dados.valor_int / dados.parcelas_int,
      valor_parcela: dados.parcelas_int,
      total: dados.valor_int,
      card,
    };

    api
      .post(`/vindi/payment/${props.match.params.plano}`, vindi_params)
      .then(() => {
        swal(
          "Confirmado!",
          "Sua assinatura foi concluída! Estamos te redirecionando para os seus cursos.",
          "success"
        );
        setLoading(false);
        setPago(true);

        setTimeout(() => {
          window.location.href = "/";
        }, 5000);
      })
      .catch(() => {
        setLoading(false);
        swal(
          "Ocorreu um erro no processamento",
          `Por favor, confira seus dados`,
          "error"
        );
      });
  };

  useEffect(() => {
    api
      .get("perfil", {
        headers: {
          "Content-type": "application/json",
          access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
        },
      })
      .then((res) => {
        setName({ ...name, value: res.data.nome });
        setCpf({ ...cpf, value: res.data.cpf });
        setBirthday({ ...birthday, value: res.data.data_nascimento });
        setCity({ ...city, value: res.data.cidade });
        setNeightboor({ ...neightboor, value: res.data.bairro });
        setNumber({ ...number, value: res.data.numero });
        setPhone({ ...phone, value: res.data.celular });
        setComplement({ ...complement, value: res.data.complemento });
        setState({ ...state, value: res.data.estado });
        setStreet({ ...street, value: res.data.endereco });
        setPostalCode({ ...postalCode, value: res.data.cep });
      });
  }, []);

  useEffect(() => {
    Axios.get(
      "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
    ).then((response) => {
      const ufInitials = response.data.map((uf) => uf.sigla);

      setUfs(ufInitials);
    });
  }, []);

  useEffect(() => {
    if (state.value === "") {
      return;
    }

    Axios.get(
      `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state.value}/municipios`
    ).then((response) => {
      const cityNames = response.data.map((uf) => uf.nome);

      setCities(cityNames);
    });
  }, [state.value]);

  const cepValidate = (cep) => {
    if (cep.replace("_", "").length === 9) {
      Axios.get(`https://viacep.com.br/ws/${cep}/json/`)
        .then((res) => {
          if (!res.data.cep) {
            setPostalCode({ value: cep, message: "CEP inválido" });
          }

          setStreet({ message: "", value: res.data.logradouro });
          setNeightboor({ message: "", value: res.data.bairro });
          setComplement({ message: "", value: res.data.complemento });
          setState({ message: "", value: res.data.uf });
          setCity({ message: "", value: res.data.localidade });
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      return "O CEP deve possuir 9 dígitos";
    }
  };

  useEffect(() => {
    if (birthday.value === "0000-00-00") {
      setBirthday({
        value: "",
        message: "",
      });
    }

    if (new Date(birthday.value)) {
      setBirthday({
        ...birthday,
        message: "",
      });
    }
  }, [birthday.value]);

  useEffect(() => {
    if (!getNodeToken()) {
      window.location.href = `/login?url_redirect=https://www.voitto.com.br/pagamento-especial/${props.match.params.plano}`;
    }

    api
      .get(`/vindi/verify_plan/${props.match.params.plano}`)
      .then((res) => {
        const dados = res.data;
        setDados(dados);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          swal(`Erro`, `${error.response.data.message}`, "error").then(() => {
            window.location.href = "/premium";
          });
        }
      });
  }, []);

  const verify = () => {
    setName({
      ...name,
      message: nameValidate(name.value),
    });
    setStreet({
      ...street,
      message: mandatoryValidate(street.value),
    });
    setBirthday({
      ...birthday,
      message: mandatoryValidate(birthday.value),
    });
    setNumber({
      ...number,
      message: mandatoryValidate(number.value),
    });
    setPostalCode({
      ...postalCode,
      message: mandatoryValidate(postalCode.value),
    });
    setCpf({
      ...cpf,
      message: cpfValidation(cpf.value),
    });
    setPhone({
      ...phone,
      message: phoneValidate(phone.value),
    });
    setState({
      ...state,
      message: mandatoryValidate(state.value),
    });
    setNeightboor({
      ...neightboor,
      message: mandatoryValidate(neightboor.value),
    });
    setCity({
      ...city,
      message: mandatoryValidate(city.value),
    });

    return (
      (name.message === "" ||
        name.message === null ||
        name.message === undefined) &&
      (phone.message === "" ||
        phone.message === null ||
        phone.message === undefined) &&
      (street.message === "" ||
        street.message === null ||
        street.message === undefined) &&
      (number.message === "" ||
        number.message === null ||
        number.message === undefined) &&
      (birthday.message === "" ||
        birthday.message === null ||
        birthday.message === undefined) &&
      (postalCode.message === "" ||
        postalCode.message === null ||
        postalCode.message === undefined) &&
      (neightboor.message === "" ||
        neightboor.message === null ||
        neightboor.message === undefined) &&
      name.value !== "" &&
      phone.value !== "" &&
      cpf.value !== "" &&
      street.value !== "" &&
      number.value !== "" &&
      birthday.value !== "" &&
      postalCode.value !== "" &&
      neightboor.value !== ""
    );
  };

  const submitData = () => {
    if (!verify()) {
      return;
    }

    try {
      const person = {
        id: getUserNode().id,
        nome: name.value,
        celular: phone.value,
        data_nascimento: birthday.value,
        cpf: cpf.value,
        cep: postalCode.value,
        endereco: street.value,
        numero: number.value,
        bairro: neightboor.value,
        complemento: complement.value,
        cidade: city.value,
        estado: state.value,
      };
      api
        .put(
          "/atualizaperfil",
          {
            ...person,
          },
          {
            headers: {
              "Content-type": "application/json",
              access_token: `voitto-token ${localStorage.getItem(
                "oauth_token"
              )}`,
            },
          }
        )
        .then(() => {
          setFullData(true);
        })
        .catch((err) => {
          console.error(err);
          swal(
            "Não foi possivel alterar o seu endereço.",
            `${err}.Faça os ajustes necessários em https://voitto.com.br/online/editar-perfil`,
            "error"
          );
        });
    } catch (err) {
      swal(
        "Erro!",
        "Verifique os dados passados e tente novamente. Se persistir, contacte o suporte!",
        "error"
      );
    }
  };

  return (
    <>
      <Topo />
      {loading && (
        <Dimmer>
          <Loader active inline="centered">
            Carregando Dados...
          </Loader>
        </Dimmer>
      )}
      <Container>
        <Box>
          {fullData ? (
            <>
              {dados && (
                <Header>
                  Assinatura de plano
                  <p>
                    {dados.nome_plano || ""} -{" "}
                    {dados.parcelas_str ? `${dados.parcelas_str},00` : ""}
                    /MENSAIS
                  </p>
                </Header>
              )}
              <CreditCardDiv>
                <CreditCard
                  placeholders={{ name: "NOME NO CARTAO" }}
                  number={cartao.number}
                  name={cartao.name}
                  expiry={cartao.expiry}
                  cvc={cartao.cvc}
                  focused={focused}
                />
                <Form style={{ marginTop: "50px", marginLeft: "-10%" }}>
                  <style>
                    {`
                  .form-group{
                    width: 300px;
                  }
                `}
                  </style>
                  <Form.Field className="field form-group">
                    <label>Número no cartão de crédito:</label>
                    <input
                      type="tel"
                      id="numero_cartao"
                      name="number"
                      className="form-control"
                      placeholder="0000 0000 0000 0000"
                      pattern="[\d| ]{16,22}"
                      onChange={(e) => handleInputCard(e)}
                      onFocus={(e) => handleInputFocus(e)}
                      maxLength={19}
                    />
                  </Form.Field>
                  <Form.Field className="field form-group">
                    <label>Nome no cartão de crédito:</label>
                    <input
                      type="text"
                      id="nome_cartao"
                      name="name"
                      className="form-control"
                      placeholder="VOITTO TREINAMENTOS"
                      onChange={(e) => handleInputCard(e)}
                      onFocus={(e) => handleInputFocus(e)}
                      maxLength={25}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>Data de validade:</label>
                    <input
                      type="tel"
                      name="expiry"
                      id="data_validade"
                      className="form-control"
                      placeholder="mês/ano"
                      pattern="\d\d/\d\d"
                      onChange={(e) => handleInputCard(e)}
                      onFocus={(e) => handleInputFocus(e)}
                      maxLength={5}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>CVC:</label>
                    <input
                      type="tel"
                      name="cvc"
                      placeholder="1234"
                      pattern="\d{3,4}"
                      onChange={(e) => handleInputCard(e)}
                      onFocus={(e) => handleInputFocus(e)}
                      onSubmit={handleSubmitCard}
                      maxLength={4}
                    />
                  </Form.Field>
                  <center>
                    <Button
                      onClick={handleSubmitCard} //disabled={pago}
                      loading={loading}
                      primary
                    >
                      Confirmar
                    </Button>
                  </center>
                </Form>
              </CreditCardDiv>
            </>
          ) : (
            <FormContainer>
              <FormLine grid="1fr">
                <InputNext
                  placeholder="Digite seu nome Completo"
                  title="Nome Completo*"
                  type="text"
                  value={name}
                  setValue={setName}
                  validate={nameValidate}
                />
              </FormLine>
              <FormLine grid="1fr 1fr">
                <InputNext
                  validate={phoneValidate}
                  placeholder="Digite seu telefone"
                  title="WhatsApp/Celular*"
                  type="text"
                  value={phone}
                  setValue={setPhone}
                  mask="(99) 99999-9999"
                />
                <InputNext
                  validate={birthdayValidate}
                  placeholder="dd/mm/aaaa"
                  title="Data de nascimento*"
                  type="date"
                  value={birthday}
                  setValue={setBirthday}
                />
              </FormLine>
              <FormLine grid="1fr">
                <InputNext
                  validate={cpfValidation}
                  placeholder="Digite seu CPF"
                  title="CPF*"
                  type="string"
                  value={cpf}
                  setValue={setCpf}
                />
              </FormLine>
              <FormLine grid="1f 1fr">
                <InputNext
                  validate={cepValidate}
                  mask="99999-999"
                  placeholder="Digite seu CEP"
                  title="CEP*"
                  type="text"
                  value={postalCode}
                  setValue={setPostalCode}
                />
                <InputNext
                  validate={mandatoryValidate}
                  placeholder="Digite seu logradouro"
                  title="Logradouro*"
                  type="string"
                  value={street}
                  setValue={setStreet}
                />
              </FormLine>
              <FormLine grid="1fr 1fr">
                <InputNext
                  validate={mandatoryValidate}
                  placeholder="Número"
                  title="Número*"
                  type="number"
                  value={number}
                  setValue={setNumber}
                />
                <InputNext
                  validate={function () {
                    return null;
                  }}
                  placeholder="Digite o Complemento"
                  title="Complemento"
                  type="text"
                  value={complement}
                  setValue={setComplement}
                />
              </FormLine>
              <FormLine grid="1fr ">
                <InputNext
                  validate={mandatoryValidate}
                  placeholder="Digite seu bairro"
                  title="Bairro*"
                  type="text"
                  value={neightboor}
                  setValue={setNeightboor}
                />
              </FormLine>
              <FormLine grid="1fr 2fr">
                <SelectNext
                  options={ufs}
                  placeholder="Selecione o estado"
                  title="Estado*"
                  value={state}
                  setValue={setState}
                />
                <SelectNext
                  options={cities}
                  placeholder="Selecione a cidade"
                  title="Cidade*"
                  value={city}
                  setValue={setCity}
                />
              </FormLine>

              <center>
                <Button onClick={submitData} loading={loading} primary>
                  Confirmar
                </Button>
              </center>
            </FormContainer>
          )}
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default PagamentoVindi;
